import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material"
import T from "../hooks/Language/T"
import useTranslationSharie from "../hooks/Language/useTranslation"

const Popup = ({ open, handleClose, handleConfirm }) => {
  const t = useTranslationSharie()
  return (
    <T>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='are-you-sure-dialog'
        aria-describedby='confirmation-dialog-description'
      >
        <DialogTitle id='are-you-sure-dialog'>{t("Are you sure?")}</DialogTitle>
        <DialogContent>
          <DialogContentText id='confirmation-dialog-description'>
            This action is irreversible. Please confirm your choice
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='secondary'>
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            color='primary'
            autoFocus
            disabled={localStorage.getItem("guest") === "true"}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </T>
  )
}

export default Popup
